import React, { memo, Suspense, useState } from 'react';
import { useDispatch } from 'react-redux';
import useFetchRates from '../../hooks/rates/useFetchRates';
import { setSelectedRateAction } from '../../redux/actions/ratesActions';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import DeleteRateModal from './modals/DeleteRateModal';
import UpdateRateModal from './modals/UpdateRateModal';
import RatesTable from './RatesTable';

const RatesList = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { loading, rates, refresh } = useFetchRates({ unpaged: false });
  const [showUpdateRateModal, setShowUpdateRateModal] = useState(false);
  const [showDeleteRateModal, setShowDeleteRateModal] = useState(false);

  const handleRateClick = (rate) => {
    dispatch(setSelectedRateAction(rate));
    setShowUpdateRateModal(true);
  };

  const handleUpdateRateModalSubmit = async () => {
    refresh();
    setShowUpdateRateModal(false);
  };

  const handleRateDeleteClick = (rate) => {
    dispatch(setSelectedRateAction(rate));
    setShowDeleteRateModal(true);
  };

  const handleDeleteRateModalSubmit = async () => {
    refresh();
    setShowDeleteRateModal(false);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        {showUpdateRateModal && (
          <UpdateRateModal
            readOnly={readOnly}
            onModalSubmit={() => handleUpdateRateModalSubmit()}
            onModalClose={() => setShowUpdateRateModal(false)}
          />
        )}
        {showDeleteRateModal && (
          <DeleteRateModal
            onModalSubmit={() => handleDeleteRateModalSubmit()}
            onModalClose={() => setShowDeleteRateModal(false)}
          />
        )}
        <>
          <RatesTable
            onRateClick={handleRateClick}
            onRateDeleteClick={handleRateDeleteClick}
            rates={rates}
            readOnly={readOnly}
            loading={loading}
          />
          {rates.length === 0 && !loading && <EmptyContent title={'Список оцінки вартості порожній'} />}
        </>
      </div>
    </Suspense>
  );
};

export default memo(RatesList);
